'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyLogger = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _localeContext = require('../../core/localeContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyLogger = exports.CopyLogger = (_dec = (0, _localeContext.localeContext)('CopyLogger', {
  copy: '复制',
  copySuccess: '复制成功'
}), _dec(_class = function (_React$PureComponent) {
  _inherits(CopyLogger, _React$PureComponent);

  function CopyLogger() {
    _classCallCheck(this, CopyLogger);

    return _possibleConstructorReturn(this, (CopyLogger.__proto__ || Object.getPrototypeOf(CopyLogger)).apply(this, arguments));
  }

  _createClass(CopyLogger, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      /**
       * copy:
       * see: https://clipboardjs.com/
       */
      this._clipboard = new _clipboard2.default(_reactDom2.default.findDOMNode(this.refs.trigger));

      this._clipboard.on('success', function (e) {
        _message2.default.info(_this2.getLocale().copySuccess);
        e.clearSelection();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._clipboard.destroy();
    }
  }, {
    key: 'render',
    value: function render() {
      var inlineStyle = {
        marginRight: '40px',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-all',
        lineHeight: '22px'
      };
      return _react2.default.createElement(
        'div',
        { style: { whiteSpace: 'nowrap' } },
        _react2.default.createElement(
          _button2.default,
          {
            style: { float: 'right' },
            ref: 'trigger',
            size: 'small',
            type: 'ghost',
            'data-clipboard-text': this.props.rid
          },
          this.getLocale().copy
        ),
        _react2.default.createElement(
          'span',
          { style: inlineStyle },
          this.props.message
        )
      );
    }
  }]);

  return CopyLogger;
}(_react2.default.PureComponent)) || _class);


//////////////////
// WEBPACK FOOTER
// ./src/components/notifier/copyLogger.jsx
// module id = 41
// module chunks = 0